import React, { Component, PropTypes } from 'react';
import { getDisplayCurrency } from 'utils/converters'
import { changeUser } from 'actions/auth'

export default class BankrollTab extends Component {

  constructor(props) {
    super(props)
    this.onChangeBankroll = this.onChangeBankroll.bind(this)
    this.onChangeCurrency = this.onChangeCurrency.bind(this)
    this.onChangeBetsize = this.onChangeBetsize.bind(this)
    this.submit = this.submit.bind(this)
    this.state = {
      currency: this.props.currency,
      startingBankroll: this.props.startingBankroll,
      kellyFrac: this.props.kellyFrac
    }
  }

  submit(e) {
    e.preventDefault()
    const { dispatch } = this.props
    let changes = {}
    if (this.state.startingBankroll !== this.props.startingBankroll) {
      changes.startingBankroll = this.state.startingBankroll
    }
    if (this.state.currency !== this.props.currency) {
      changes.currency = this.state.currency
    }
    if (this.state.kellyFrac !== this.props.kellyFrac)
      changes.kellyFrac = this.state.kellyFrac
    if (Object.keys(changes).length > 0) {
      dispatch(changeUser(this.props.userId, changes))
    }
  }

  onChangeBankroll(e) {
    e.preventDefault()
    this.setState({
      startingBankroll: +e.target.value
    })
  }

  onChangeCurrency(e) {
    e.preventDefault()
    this.setState({
      currency: e.target.value
    })
  }

  onChangeBetsize(e) {
    e.preventDefault()
    this.setState({
      kellyFrac: +e.target.value
    })
  }

  render() {
    return (
      <form className='form-horizontal'>
        <fieldset>
          <div className='form-group'>
            <label htmlFor='currency' className='col-xs-2 control-label'>Main currency</label>
            <div className='col-xs-10'>
              <select className='form-control' value={this.state.currency} onChange={this.onChangeCurrency}>
                { this.props.currencies.map(currency => {
                    return <option key={currency} value={currency}>{ getDisplayCurrency[currency] }</option>
                })}
              </select>
            </div>
          </div>
          <div className='form-group'>
            <label htmlFor='startingBankroll' className='col-xs-2 control-label'>Starting bankroll</label>
            <div className='col-xs-10'>
              <div className='input-group'>
                <input type='number' className='form-control' value={this.state.startingBankroll} onChange={this.onChangeBankroll}/>
                <span className='input-group-addon'>{ getDisplayCurrency[this.state.currency] }</span>
              </div>
            </div>
          </div>
          <div className='form-group'>
            <label htmlFor='betsizing' className='col-xs-2 control-label'>Bet sizing</label>
            <div className='col-xs-10'>
              <select className='form-control' value={this.state.kellyFrac} onChange={this.onChangeBetsize}>
                <option value={0.30}>Low risk</option>
                <option value={0.5}>Medium risk</option>
                <option value={1}>High risk</option>
              </select>
            </div>
            <div className='col-xs-10 col-xs-offset-2'>
              <p className='text-muted'>Want to learn more about betsizing? See our <a href='http://blog.edgebet.net/betsize-and-simulations' target="_blank">blog post</a></p>
            </div>
          </div>
          <div className='form-group'>
            <div className='col-xs-10 col-xs-offset-2'>
              <button type='submit' className='btn btn-primary' onClick={this.submit}>Update</button>
            </div>
          </div>
        </fieldset>
      </form>
    )
  }
}

BankrollTab.propTypes = {
  startingBankroll: PropTypes.number.isRequired,
  currency: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  currencies: PropTypes.array,
  userId: PropTypes.string.isRequired
}



/** WEBPACK FOOTER **
 ** ./src/components/profile/BankrollTab.js
 **/